import * as Lib from "metabase-lib";
import Question from "metabase-lib/v1/Question";
import type Metadata from "metabase-lib/v1/metadata/Metadata";
import type {
  CardDisplayType,
  DatabaseId,
  NativeDatasetQuery,
  VisualizationSettings,
} from "metabase-types/api";

/** An empty native query, optionally pre-pointed at a database. */
export function createEmptyNativeQuery(
  databaseId: DatabaseId | null = null,
): NativeDatasetQuery {
  return {
    type: "native",
    database: databaseId,
    native: { query: "", "template-tags": {} },
  };
}

export type CreateNativeQuestionOptions = {
  databaseId: DatabaseId | null;
  sql: string;
  metadata: Metadata;
  display?: CardDisplayType;
  visualizationSettings?: VisualizationSettings;
};

/**
 * Build a native question from a data source and some SQL.
 *
 * The SQL is applied through `Lib.withNativeQuery` rather than written straight
 * into the query map, because that is what derives the template tags behind
 * `{{snippet: …}}` and `{{#123-a-model}}` references. Assembling the map by
 * hand would leave those references unresolvable at run time.
 */
export function createNativeQuestion({
  databaseId,
  sql,
  metadata,
  display,
  visualizationSettings,
}: CreateNativeQuestionOptions): Question {
  const question = Question.create({
    dataset_query: createEmptyNativeQuery(databaseId),
    metadata,
    display,
    visualization_settings: visualizationSettings,
  });
  if (sql === "") {
    return question;
  }
  return question.setQuery(Lib.withNativeQuery(question.query(), sql));
}

/** The SQL text of a question's native query. */
export function getQuestionSql(question: Question): string {
  return Lib.rawNativeQuery(question.query()) ?? "";
}
